import { Route } from 'react-router';

import AdminLayout from '../contexts/shared/components/layouts/AdminLayout'
import PrivateRoute from './PrivateRoute'
import Dashboard from '../contexts/backoffice/dashboard/ui/pages/Dashboard'
import UserDetail from '../contexts/backoffice/users/ui/pages/UserDetail'
import EventDetail from '../contexts/backoffice/events/ui/pages/EventDetail'
import Brands from '../contexts/backoffice/brands/ui/pages/Brands'
import BrandsView from '../contexts/backoffice/brands/ui/pages/BrandsView'
import Users from '../contexts/backoffice/users/ui/pages/Users'
import IntegrationsAPI from '../contexts/backoffice/integrations/IntegrationsAPI'
import Courses from '../contexts/backoffice/courses/ui/pages/Courses'
import CourseDetail from '../contexts/backoffice/courses/ui/pages/CourseDetail'
import ManagementCourses from '../contexts/backoffice/courses/ui/pages/ManagementCourses'
import LessonsView from '../contexts/backoffice/lessons/ui/pages/LessonsView'
import Sliders from '../contexts/backoffice/sliders/ui/pages/Sliders'
import SliderDetail from '../contexts/backoffice/sliders/ui/pages/SliderDetail'
import Offers from '../contexts/backoffice/offers/ui/pages/Offers'
import OfferDetail from '../contexts/frontoffice/offers/ui/pages/OfferDetail'
import News from '../contexts/backoffice/news/ui/pages/News'
import NewsDetail from '../contexts/backoffice/news/ui/pages/NewsDetail'
import Novelties from '../contexts/backoffice/novelties/ui/pages/Novelties'
import NoveltyDetail from '../contexts/backoffice/novelties/ui/pages/NoveltyDetail'
import AdminLearningRoutes from '../contexts/backoffice/learningPaths/ui/pages/ClientLearningRoutes'
import Seminars from '../contexts/backoffice/seminars/ui/pages/Seminars'
import SeminarDetail from '../contexts/backoffice/seminars/ui/pages/SeminarDetail'
import AdminLibrary from '../contexts/backoffice/library/ui/pages/AdminLibrary'
import ResourceDetail from '../contexts/backoffice/library/ui/pages/ResourceDetail'
import Events from '../contexts/backoffice/events/ui/pages/Events'

export const AdminRoutes = (
  <>
    <Route path="/" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
      <Route path="/escritorio" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/usuarios/perfil" element={<PrivateRoute><UserDetail /></PrivateRoute>} />
      <Route path="/evento/detalle" element={<PrivateRoute><EventDetail /></PrivateRoute>} />
    </Route>

    <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
      <Route path="marcas" element={<Brands />} />
      <Route path="marcasView" element={<BrandsView />} />
      <Route path="usuarios" element={<Users />} />
      <Route path="usuarios/:id" element={<UserDetail />} />
      <Route path="integraciones" element={<IntegrationsAPI />} />
      <Route path="cursos" element={<Courses />} />
      <Route path="cursos/:brandId/:slug" element={<CourseDetail />} />
      <Route path="cursos/ordenamiento" element={<ManagementCourses />} />
      <Route path="courseName/lessonName" element={<LessonsView />} />
      <Route path="sliders" element={<Sliders />} />
      <Route path="sliders/:id" element={<SliderDetail />} />
      <Route path="ofertas" element={<Offers />} />
      <Route path="ofertas/:id" element={<OfferDetail />} />
      <Route path="noticias" element={<News />} />
      <Route path="noticias/:slug" element={<NewsDetail />} />
      <Route path="novedades" element={<Novelties />} />
      <Route path="novedades/:slug" element={<NoveltyDetail />} />
      <Route path="rutas-de-formacion" element={<AdminLearningRoutes />} />
      <Route path="events" element={<Events />} />
      <Route path="events/:id" element={<EventDetail />} />
      <Route path="seminarios" element={<Seminars />} />
      <Route path="seminarios/:id" element={<SeminarDetail />} />
      <Route path="biblioteca" element={<AdminLibrary />} />
      <Route path="biblioteca/:id" element={<ResourceDetail />} />
    </Route>
  </>
);
